// De soorten die via een storytelling-deellink ingestuurd kunnen worden, en
// hun namen. Eén plek voor de openbare pagina, het venster 'Deellink' en de
// tab 'Te beoordelen'. De volgorde is die van de server (validateSubmission.js
// KINDS); functions/storytelling/submissions/kindsParity.test.js houdt ze gelijk.
// AI-CONTEXT: See docs/features/storytelling-deellink.md

/**
 * @typedef {object} StorytellingKind
 * @property {'media'|'quote'|'anecdote'} id
 * @property {string} label - Naam op het scherm
 */

/** @type {Array<StorytellingKind>} */
const STORYTELLING_KINDS = [
    { id: 'media', label: 'Foto of video' },
    { id: 'quote', label: 'Quote' },
    { id: 'anecdote', label: 'Anekdote' },
]

/** @type {Record<string, string>} */
const STORYTELLING_KIND_LABELS = Object.fromEntries(STORYTELLING_KINDS.map((k) => [k.id, k.label]))

/**
 * De naam van een activiteit uit de lijst van de hook.
 * @param {Array<{ID: string, Activity?: string}> | string} activities - '' zolang de hook laadt
 * @param {string} id
 * @returns {string} De naam, of '' als hij (nog) niet te vinden is
 */
const activityNameById = (activities, id) => (Array.isArray(activities) ? activities.find((a) => a.ID === id)?.Activity : '') || ''

export { STORYTELLING_KINDS, STORYTELLING_KIND_LABELS, activityNameById }
